<template>
  <v-card style="margin-top: 20px" color="background">
    <v-card-title v-if="title" class="justify-center" style="font-size: 17px">
      <b>{{ title }}</b>
    </v-card-title>
    <v-card-subtitle align="center">
      <v-container>
        <v-row>
          <v-col>
            <b style="font-size: 11px">{{ $t('Number:') }}</b> <br>
            <b style="color: #43E1B2; font-size: 18px; ">{{ invoice.number }}</b>
          </v-col>
          <v-col v-if="!invoiceOld">
            <b style="font-size: 11px">{{ $t('Payer CIF:') }}</b><br>
            <b style="color: #43E1B2; font-size: 18px">{{ invoice.payerCif }}</b>
          </v-col>
          <v-col v-else>
            <b style="font-size: 11px">{{ $t('Payer CIF:') }}</b> <br>
            <b style="color: #43E1B2; font-size: 18px">{{ invoiceOld.payerCif }}</b><br>
            <span v-if="samePayer()" style="font-size: 13px; color: #FF6961; font-weight: bold">{{ $t('ShowInvoiceInformation.New Payer cif: ') + invoice.payerCif }}</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col v-if="!invoiceOld">
            <b style="font-size: 11px">{{ $t('Amount:') }}</b> <br>
            <b style="color: #43E1B2; font-size: 18px">{{ invoice.amount }} €</b>
          </v-col>
          <v-col v-else>
            <b style="font-size: 11px">{{ $t('Amount:') }}</b><br>
            <b style="color: #43E1B2; font-size: 18px">{{ invoiceOld.amount }} {{ '€' }}</b><br>
            <span v-if="sameAmount()" style="font-size: 13px; color: #FF6961; font-weight: bold">{{ $t('New Amount: ') + invoice.amount + ' €' }}</span>
          </v-col>
          <v-col v-if="!invoiceOld">
            <b style="font-size: 11px">{{ $t('Receiver CIF:') }}</b><br>
            <b style="color: #43E1B2; font-size: 18px">{{ invoice.receiverCif }}</b>
          </v-col>
          <v-col v-else>
            <b style="font-size: 11px">{{ $t('Receiver CIF:') }}</b> <br>
            <b style="color: #43E1B2; font-size: 18px">{{ invoiceOld.receiverCif }}</b><br>
            <span v-if="sameReceiver()" style="font-size: 13px; color: #FF6961; font-weight: bold">{{ $t('ShowInvoiceInformation.New Receiver CIF: ') + invoice.receiverCif }}</span>
          </v-col>
        </v-row>
      </v-container>
    </v-card-subtitle>
  </v-card>
</template>

<script>

export default {
    name: "ShowInvoiceInformation",
    props: {
        title: {
            type: String,
            default: null
        },
        invoice: {
            type: Object,
            default: null
        },
        invoiceOld: {
            type: Object,
            default: null
        },
    },
    created () {
        console.log("INVOICE ");
    },
    methods: {
        show () {
        },
        samePayer () {
            return this.invoice.payerCif !== this.invoiceOld.payerCif;
        },
        sameReceiver () {
            return this.invoice.receiverCif !== this.invoiceOld.receiverCif;

        },
        sameAmount () {
            return this.invoice.amount !== this.invoiceOld.amount;

        }
    }
};
</script>

<style scoped>

</style>
